import { faClose } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { DATE_FORMAT } from "@gymflow/common";
import { ReactNode } from "react";
import { DateRange, DateRange as DateRangeDayPicker } from "react-day-picker";

import { useClubSettings } from "../../providers";
import { Button, DownloadIcon, FilterIcon } from "../atoms";
import DateRangePicker from "../forms/DateRangePicker";
import RangeDatePicker, {
  DateSelectionRange,
} from "./RangeDatePicker/RangeDatePicker";

export interface ReportProps {
  title: string;
  description: string;
  onDownloadClick?: () => Promise<void>;
  renderMoreButtons?: () => ReactNode;
  showFilters?: () => void;
  filtersAppliedCount?: number;
  handleDateRangeChange?: (range: DateSelectionRange) => void;
  dateRange?: DateRange | { startDate: string; endDate: string };
  close?: () => void;
  table: JSX.Element;
  onDateSelectionApply?: (
    range:
      | DateRangeDayPicker
      | {
          startDate: string;
          endDate: string;
        }
      | undefined,
  ) => void;
}

export const Report = ({
  title,
  description,
  renderMoreButtons,
  onDownloadClick,
  showFilters,
  filtersAppliedCount,
  handleDateRangeChange,
  dateRange,
  close,
  table,
  onDateSelectionApply,
}: ReportProps) => {
  const { featureFlags, properties } = useClubSettings();

  const longDateFormat = properties.longDateFormat;

  return (
    <div className="bg-gray-0 flex h-screen flex-col justify-between">
      <div className="flex flex-row items-center justify-between">
        <div className="relative flex flex-1 flex-row flex-wrap items-center justify-between pb-8 pl-8 pr-4 pt-10">
          <div className="mr-4 flex max-w-[800px] flex-col">
            <div className="text-lg font-semibold">{title}</div>
            <div className="text-sm text-gray-600">{description}</div>
          </div>
          <div className="flex flex-wrap items-center">
            {renderMoreButtons && renderMoreButtons()}
            {onDownloadClick && (
              <Button className="mr-4" onClick={onDownloadClick}>
                <DownloadIcon pathClassName="stroke-gray-500" />
              </Button>
            )}

            {showFilters && (
              <Button
                className="mr-4 flex h-11"
                onClick={showFilters}
                badgeContent={filtersAppliedCount}
              >
                <FilterIcon className="mr-2" pathClassName="stroke-gray-500" />
                Filter
              </Button>
            )}
            {onDateSelectionApply &&
              featureFlags.PORTAL_NEW_REPORTS_DATE_PICKER && (
                <RangeDatePicker
                  onDateSelectionApply={onDateSelectionApply}
                  dateRange={dateRange as DateRange}
                />
              )}

            {!featureFlags.PORTAL_NEW_REPORTS_DATE_PICKER &&
              handleDateRangeChange && (
                <DateRangePicker
                  className=""
                  displayDateFormat={longDateFormat}
                  onChange={handleDateRangeChange}
                  value={dateRange}
                  dateFormat={DATE_FORMAT}
                  onSelectionChange={undefined}
                  placeholder={undefined}
                />
              )}
          </div>
        </div>
        {close && (
          <div
            className="mr-6 flex size-11 cursor-pointer items-center justify-center pb-8 pt-10"
            onClick={close}
          >
            <FontAwesomeIcon className="text-xl text-gray-500" icon={faClose} />
          </div>
        )}
      </div>
      {table}
    </div>
  );
};
